import { CategoryIds } from '@/appsync/graphql/menu';
import { ID } from '@/types/type';

// LoginUserAllInfoQueryService.ts
export type CategoryIdsCollection = CategoryIds[];
export const getMenusByIds = (
  categoryIdsCollection: CategoryIdsCollection
): string => /* GraphQL */ `
  query GetMenusByIds(
    $loginName: String!
    $tenant: String!
    $landscape: String!
  ) {
    ${categoryIdsCollection
      .map(categoryIds =>
        categoryIds.ids
          .map((id, index) =>
            getCommonMenusContent(categoryIds.category, id, index)
          )
          .join('')
      )
      .join('')}
  }
`;
const getCommonMenusContent = (
  category: string,
  id: ID,
  index: number
): string => {
  return `
    ${category}Result${index}: getMenu(
      menuId: "${id}"
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      menuId
      menuNames {
        items {
          language
          name
        }
        nextToken
      }
      menuDescriptions {
        items {
          language
          description
        }
        nextToken
      }
      url
      accessedTimeStamp
      canUseFromExtra
      product
      menuIconFont
    }
  `;
};

// MenuQueryService.ts
export const getMenus = (idList: ID[]): string => /* GraphQL */ `
  query GetMenus(
    $loginName: String!
    $tenant: String!
    $landscape: String!
  ) {
    ${idList.map(getMenusContent).join('')}
  }
`;
const getMenusContent = (id: ID, index: number): string => {
  return `
    result${index}: getMenu(
      menuId: "${id}"
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      menuId
      menuNames {
        items {
          language
          name
        }
        nextToken
      }
      menuDescriptions {
        items {
          language
          description
        }
        nextToken
      }
      url
      accessedTimeStamp
      canUseFromExtra
      product
      menuIconFont
    }
  `;
};
